(function () {
	'use strict';

	angular.module('sempraWebapp').factory('OrganizationDetailsViewModel', OrganizationDetailsViewModelFactory);

	/** @ngInject */
	function OrganizationDetailsViewModelFactory($translate) {
		function OrganizationDetailsViewModel() {
			this.parentOrganizationName = '';
			this.organizationType = '';
			this.organizationName = '';
			this.organizationAddress = '';
			this.typeSelector = '';
			this.typeSelectorList = [];
			this.supportedOrganization = '';
			this.supportedOrganizationType = '';
			this.organizationList = [];
			this.placeHolderText = $translate.instant("SELECT_ORGANIZATION_SELECTOR");
			this.hideSelectorList = true;
			this.organizationTypeSelectorInEditMode = null;
			this.organizationTypes = [
				{
					name: 'Company',
					value: 'COMPANY'
				},
				{
					name: 'Region',
					value: 'REGION'
				},
				{
					name: 'Site',
					value: 'SITE'
				},
				{
					name: 'Self',
					value: 'SELF'
				}
			];
			this.voucherExpirationDays = '';
		}

		OrganizationDetailsViewModel.prototype.destroy = function () {

		};

		OrganizationDetailsViewModel.prototype.refreshTypeSelectorList = function (data) {
			this.typeSelectorList = data;
		};

		OrganizationDetailsViewModel.prototype.refreshOrganizationList = function (data) {
			this.organizationList = data;
		};

		return OrganizationDetailsViewModel;
	}
})();
